import { OrderItem as OrderItemModel, OrderStaff } from '@spike/order-model';
import { FunctionComponent } from 'react';
import ItemContainer from './ItemContainer';
import OrderItemData from './UI/OrderItemData';

export interface OrderItemProps {
    type: string;
    orderItem: OrderItemModel;
    staff?: OrderStaff;
    className?: string;
}

export const OrderItem: FunctionComponent<OrderItemProps> = props => {
    return (
        <ItemContainer className={props.className}>
            <OrderItemData
                type={props.type}
                orderItem={props.orderItem}
                staff={props.staff}
            />
        </ItemContainer>
    );
};

export default OrderItem;
